import { modifier } from 'ember-modifier';
export default modifier(function onDocument(_, [event, handler]) {
  function handle(event) {
    handler(event);
  }
  document.addEventListener(event, handle);
  return () => {
    document.removeEventListener(event, handle);
  };
});